<template>
  <div id="app">
    <header class="mt__header" :class="{'mt__headerStyle':headerStyle}">
      <div class="mt__center">
        <router-link to="/index">
          <img src="./assets/logo0.png" class="mt__logo0" style="margin-top:13px;">
          <img src="./assets/logo1.png" class="mt__logo1" style="margin-top:13px;">
        </router-link>
        <div class="mt__content--right">
          <div
            class="mt__tab"
            v-for="(value, key) in tabs"
            :key="key"
            :class="{ 'mt__tab--active': value.active }"
            @click="tabClick(value)"
          >{{value.label}}</div>
        </div>
      </div>
    </header>
    <router-view/>
    <div @click="backtotop()" :style="styleObject" :class="{'mt__backtotop':sticky}"></div>
    <footer class="mt__footer">
      <span class>©2006-2023 名通科技股份有限公司 版权所有</span>
      <a href="https://xyt.xcc.cn/getpcInfo?sn=1625679813408669696&language=CN&certType=8&url=*.mastercom.cn" target="_blank" style="position: relative;display: inline-block;height: 38px;">
        <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
        <embed src="https://program.xinchacha.com/web/1625679813408669696=*.mastercom.cn.svg" width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
      </a>
      <span>
        <a href="http://beian.miit.gov.cn" target="_blank" style="color: #ffffff;">粤ICP备16017576号</a> 深圳网站建设
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      tabs: {
        index: { label: "首页", name: "index", active: false },
        about: { label: "关于名通", name: "about", active: false },
        product: { label: "产品中心", name: "product", active: false },
        job: { label: "招贤纳士", name: "job", active: false },
        contact: { label: "联系我们", name: "contact", active: false }
      },
      styleObject: {
        bottom: "100px",
        right: "20px"
      },
      sticky: false,
      beforeScrollTop: 0,
      headerStyle: false
    };
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    let right = (document.documentElement.clientWidth - 1200) / 2 - 100;
    if (right < 20) {
      right = 20;
    }
    this.styleObject.right = right + "px";

    this.tabs[this.$store.state.activeName].active = true;
  },
  updated() {
    for (const key in this.tabs) {
      if (key == this.$store.state.activeName) {
        this.tabs[key].active = true;
      } else {
        this.tabs[key].active = false;
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      if (scrollTop > clientHeight) {
        this.sticky = true;
      } else {
        this.sticky = false;
      }

      let obj = document.querySelector(".mt__main .mt__center");
      let centerTop = obj.offsetTop;
      //判断是否有父容器，如果存在则累加其边距
      while ((obj = obj.offsetParent)) {
        centerTop = centerTop + obj.offsetTop; //叠加父容器的上边距
      }
      if (centerTop < scrollTop) {
        this.headerStyle = true;
      } else {
        this.headerStyle = false;
      }

      let scrollLeft =
        document.documentElement.scrollLeft || document.body.scrollLeft;
      let headerLeft = document.querySelector(".mt__header");
      headerLeft.scrollLeft = scrollLeft;

      // let center = document.querySelector(".mt__center");
      // if (center.currentStyle) {
      //   this.marginLeft = center.currentStyle["marginLeft"];
      // } else {
      //   this.marginLeft = getComputedStyle(center, null)["marginLeft"];
      // }
      // this.marginLeft = parseInt(this.marginLeft.slice(0, -2));
      if (document.documentElement.clientWidth < 1200) {
        let fixedLeft = document.querySelector(".mt__sticky");
        if (fixedLeft) {
          fixedLeft.style.left = -scrollLeft + "px";
        }
      }
    },
    tabClick(tab) {
      this.$router.push(tab.name);
      let that = this;
      setTimeout(function() {
        that.headerStyle = false;
      }, 20);
    },
    backtotop() {
      scrollTo(0, 0);
    }
  }
};
</script>

<style>
@import './assets/flex.css';
.custom-scrollbar {
  overflow: overlay;
  position: relative;
  padding-bottom: 6px;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 14px;
  padding: 0;
}
.custom-scrollbar::-webkit-scrollbar-button {
  display: block;
  width: 0;
  height: 0;
}
.custom-scrollbar::-webkit-scrollbar-corner {
  background-color: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: rgba(128, 133, 144, 0.3);
}
.custom-scrollbar ::-webkit-scrollbar-track {
  border-radius: 6px;
  background: rgba(128, 133, 144, 0.1);
}
/* 字体抗锯齿渲染 */
#app {
  font-family: "Microsoft YaHei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1200px;
}
body {
  margin: 0;
}

/* 布局 */
.mt__header {
  height: 60px;
  width: 100%;
  overflow: hidden;
  position: fixed;
  background-color: white;
  z-index: 64;
}
.mt__main {
  padding-top: 60px;
  min-height: calc(100vh - 141px);
}
.mt__footer {
  background-color: #1f2933;
  padding: 30px 20%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.mt__footer span {
  color: #ffffff;
  font-size: 12px;
}

/* 布局 */
.mt__banner {
  height: 280px;
  background-position: center;
  background-repeat: no-repeat;
}
.mt__center {
  width: 1200px;
  margin: 0 auto;
}
.mt__main > .mt__center {
  margin: 0 auto;
  padding: 60px 0 80px 0;
}

.mt__content--table {
  display: table;
  width: 100%;
  table-layout: fixed;
  text-align: center;
}
.mt__content--main {
  display: table-row;
}
.mt__content--main > * {
  display: table-cell;
  vertical-align: top;
}
.mt__center > .mt__content--main > div:first-child {
  width: 220px;
  padding-top: 20px;
}
.mt__center > .mt__content--main > div:last-child {
  padding: 0 0 0 40px;
}

.mt__sticky {
  position: fixed;
  top: 70px;
}
.mt__content--center {
  text-align: center;
}
.mt__content--right {
  float: right;
}

/* tab页样式 */
.mt__tab {
  display: inline-block;
  margin-right: 40px;
  font-size: 14px;
  cursor: pointer;
  line-height: 60px;

  color: #4d4d4d;
}
.mt__tab:last-child {
  margin-right: 0;
}
.mt__tab--active {
  color: #0b87e6;
  font-weight: bold;
}

.mt__headerStyle {
  background-color: #0c8ff2;
}
.mt__headerStyle .mt__logo0 {
  display: none;
}
.mt__header:not(.mt__headerStyle) .mt__logo1 {
  display: none;
}
.mt__headerStyle .mt__tab {
  color: #ffffff;
}

.el-tabs__item.is-left {
  color: #808080;
}
.el-tabs__item:hover {
  color: #0b87e6;
}
.el-tabs__item.is-active {
  color: #0b87e6;
}
/* 左侧悬浮tab页样式 */
.el-tabs__nav-wrap.is-left::after {
  background-color: transparent;
}
.el-tabs--left .el-tabs__active-bar.is-left {
  width: 4px;
}
.el-tabs--left .el-tabs__item.is-left {
  font-size: 18px;
  line-height: 50px;
  height: 50px;
  width: 210px;
}
.el-tabs--left .el-tabs__item.is-left::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  background-color: #e4e7ed;
  z-index: -1;
}
.el-tabs--left .el-tabs__item.is-left:last-child::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #e4e7ed;
  z-index: -1;
}

/* 表格样式 */
.el-table__header th {
  color: #333333;
  background-color: #cee9fc;
  padding: 5px 0;
}
.el-table__row {
  color: #333333;
  cursor: pointer;
}
.el-table__expand-icon .el-icon-arrow-right {
  color: #999999;
  font-size: 14px;
  font-weight: 900;
}
.el-table__expand-icon--expanded .el-icon-arrow-right {
  color: #0b87e6;
}
.el-table th:first-child .cell,
.el-table td:first-child .cell {
  padding-left: 20px;
}
.el-table__expanded-cell[class*="cell"] {
  padding: 20px;
  line-height: 28px;
}
.el-table__row.expanded td {
  border-bottom-color: transparent;
}
.el-table__expanded-cell b {
  color: #333333;
}
.el-table__expanded-cell b:not(:first-child):before {
  content: "\A";
  white-space: pre;
}

/* 轮播样式 */
.el-carousel__button {
  width: 10px;
  height: 7px;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  opacity: 0.3;
}
.el-carousel__indicator.is-active .el-carousel__button {
  width: 30px;
}

#certificate .el-carousel__button {
  background: #000000;
  width: 8px;
  height: 8px;
}
#certificate .el-carousel__indicator.is-active .el-carousel__button {
  background: #4099ff;
}

/* 按钮样式 */
.el-button--small span {
  line-height: 1;
}

/* 卡片样式 */
.el-card {
  border-radius: 0;
}

.mt__backtotop {
  height: 54px;
  width: 54px;
  background-repeat: no-repeat;
  position: fixed;
  background-image: url("./assets/backtotop.png");
  cursor: pointer;
}
.mt__backtotop:hover {
  background-image: url("./assets/backtotophover.png");
}
.mt__backtotop:active {
  background-image: url("./assets/backtotoppress.png");
}

/* 文字 */
h1 {
  font-size: 24px;
  font-weight: normal;
  color: #1a1a1a;
}
h2 {
  font-size: 20px;
  font-weight: normal;
  color: #1a1a1a;
}
h3 {
  font-size: 18px;
  font-weight: normal;
  color: #1a1a1a;
}
p {
  font-size: 14px;
  text-align: left;
  color: #4d4d4d;
  line-height: 24px;
  letter-spacing: 0.25px;
  text-align: justify;
}
span {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
}
hr {
  clear: both;
  background-color: #f5f6f7;
  opacity: 0.5;
  border: none;
  height: 1px;
  margin: 60px 0;
}
a {
  text-decoration: none;
}
img {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue